<template>
  <div id="app">
    <top v-show="!(path === '/login')"></top>
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import top from "@/views/top"

export default {
  name: 'App',
  data() {
    return {
      path: '',
    };
  },
  components: {
      top
  },
  watch: {
    $route(to, from) {
      this.path = to.path
    }
  },
  mounted() {
    this.path = this.$route.path
  },
}
</script>

<style>

#app {
  color: #333;
  height: 100%;
  background: #fafafa;
  position: relative;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue